export const RightShipInspectionRoutes = {
    SaveRightShipInspection: "RightShipInspection/SaveRightShipInspection",
    ChangeRightShipInspectionValidityDate: "RightShipInspection/ChangeRightShipInspectionValidityDate",
    GetRightShipInspection: "RightShipInspection/GetRightShipInspection",
    GetRightShipInspectionByGuid: "RightShipInspection/GetRightShipInspectionByGuid",
    GetRequiredRightShipInspection: "RightShipInspection/GetRequiredRightShipInspection",
    ChangeStatus: "RightShipInspection/ChangeStatus",
    GetRightShipInspectionClientModel: "RightShipInspection/GetRightShipInspectionClientModel",
    GetRightShipInspectionClientModelFromGuid: "RightShipInspection/GetRightShipInspectionClientModelFromGuid",
    SendRightShipInspectionEmail: "RightShipInspection/SendRightShipInspectionEmail",
    SendCrewMatrixInspectionEmail: "RightShipInspection/SendCrewMatrixInspectionEmail",
    CreateFormTask: "RightShipInspection/CreateFormTask",
    RetrieveAndStoreCrewMatrixPdf:  "RightShipInspection/RetrieveAndStoreCrewMatrixPdf",
    ChangeInspectionCompany: "RightShipInspection/ChangeInspectionCompany",
    ChangeRSInspectionInspector: "RightShipInspection/ChangeRSInspectionInspector",
    GetInspectorReport: "RightShipInspection/GetInspectorReport",
    GetCrewMatricesByInspectionIdResponse: "RightShipInspection/GetCrewMatricesByInspectionId",
    GetRSInspectionNonConformity: "RightShipInspection/GetRSInspectionNonConformity",
    GetRSInspectionOutcome: "RightShipInspection/Outcome",
    ChangeInspectionWorkflow: "RightShipInspection/ChangeInspectionWorkflow",
    DownloadInspectionInspectorReportPdf: "RightShipInspection/DownloadInspectionInspectorReportPdf",
    GetRightShipInspectionExecutiveSummary: "RightShipInspection/GetRightShipInspectionExecutiveSummary",
    CheckAlreadySubmittedRSInspectionCompanyResponse: "RightShipInspection/CheckAlreadySubmittedRSInspectionCompanyResponse",
    SubmitRSInspectionCompanyResponse: "RightShipInspection/SubmitRSInspectionCompanyResponse",
    SaveRightShipInspectionBillingDetails: "RightShipInspection/SaveRightShipInspectionBillingDetails",
    RestoreFindingToAIContent: "RightShipInspection/RestoreFindingToAIContent",
    SaveFindingGrading: "RightShipInspection/SaveFindingGrading",
    UpdateInspectionReports: "RightShipInspection/updateInspectionReports",
    ResendInspectionRequiredEmail: "RightShipInspection/ResendInspectionRequiredEmail",
    AssignInspectorAssignment: "RightShipInspection/AssignInspectorAssignment",
    InviteInspector: "RightShipInspection/InviteInspector",
    ResendBookingRequest: "RightShipInspection/ResendBookingRequest",
    ChangeAssignedInspectors: "RightShipInspection/ChangeAssignedInspectors",
    ResendAcceptanceEmails: "RightShipInspection/ResendAcceptanceEmails",
    ResendInvoiceEmail: "RightShipInspection/ResendInvoiceEmail",
    GetFindingExtractionStatus: "RightShipInspection/GetFindingExtractionStatus",
    GetInspectionThumbnailZipFile: "RightShipInspection/GetInspectionThumbnailZipFile",
    GetRightShipInspectionDocumentLinks: "RightShipInspection/GetRightShipInspectionDocumentLinks",
    GetFindingAllDocumentsCount: "RightShipInspection/GetFindingAllDocumentsCount",
    GetInsights: "RightShipInspection/GetInsights",
    GetAiInsights: "RightShipInspection/GetAiInsights",
    GetInspectionOutcomeFindingSummary: "RightShipInspection/Outcome/GetInspectionOutcomeFindingSummary",
    ComputeValidity: "RightShipInspection/ComputeValidity"
}
